import { Component, OnInit, OnDestroy } from '@angular/core';
// Data/Class/Interface/Others
import Tabulator from 'tabulator-tables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { WHAT } from 'src/app/shared/classes';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessagesService } from 'src/app/services/message/messages.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { BaseModalComponent } from 'src/app/shared/modals/base-modal/base-modal.component';
import { EventsService } from 'src/app/services/events/events.service';
import { LicenseCreateComponent } from 'src/app/shared/modals/license-create/license-create.component';
import { LicenseDeleteComponent } from 'src/app/shared/modals/license-delete/license-delete.component';


@Component({
    selector: 'app-license',
    templateUrl: './license.component.html',
    styleUrls: ['./license.component.less']
  })

export class LicenseComponent implements OnInit {
    private table: Tabulator;

   private todaysDate = new Date().toISOString();
   private allUsers = [];
   private filterStateObj = {
    currentFilter: '',
    currentData: [],
    allData: []
   };

   public listOfLicensesForRemoval = [];
   
   constructor(private ngbModal: NgbModal, private admin: AdminService, private load: NgxSpinnerService, private msg: MessagesService,
        private utils: UtilsService, private events: EventsService) { }
    ngOnInit() {
      this.load.show();
      this.initTable();
      this.getAllLicenses();

      }

     // create license
  public createLicense() {
    this.ngbModal.open(LicenseCreateComponent, {
      size: 'lg'
    });
  }

  // inits the table
  private initTable() {
    this.table = new Tabulator('#licenseTable', {
      responsiveLayout: 'collapse',
      pagination: 'local',
      paginationSize: 15,
      paginationSizeSelector: true,
      index: 'id',
      layout: 'fitColumns',
      columns: [
        {title: 'First Name', field: 'first_name', sorter: 'string' },
        {title: 'Last Name', field: 'last_name', sorter: 'string' },
        {title: 'Organization', field: 'organization', sorter: 'string' },
        {title: 'Email', field: 'email', sorter: 'number'},
        {title: 'Phone', field: 'phone', sorter: 'string'},
        {
          title: 'Created On', field: 'created_at',sorter:'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
          }
        },
        {
          title: 'Expired On', field: 'expired_date', sorter: 'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
          }
        },
        {title: 'App Version', field: 'app_version', sorter: 'string'},
        {title: 'id', field: 'id',visible:false}
      ],
      rowClick: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'license',
          data: data
        };

        // mouse click event
        this.loadModal(newData);
      },
      rowTap: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'license',
          data: data
        };

        // touch screen tap
        this.loadModal(newData);
      }
    });
  }
      // open modal and pass license data to it
  private loadModal(data) {
    const userModal = this.ngbModal.open(BaseModalComponent, {
      size: 'lg'
    });

    userModal.componentInstance.data = data;
  }

  public addToRemoval(e, id) {
    e.stopPropagation();
    e.preventDefault();

    // add to global component removal array
    if (this.listOfLicensesForRemoval.indexOf(id) === -1) {
      this.listOfLicensesForRemoval.push(id);
    } else {
      this.listOfLicensesForRemoval.splice(this.listOfLicensesForRemoval.indexOf(id), 1);
    }
  }

  private getAllLicenses() {
    this.admin.GET(WHAT.Licenses)
      .then(res => this.success(res))
      .catch(err => this.error(err));
  }

  
  // handle success
  private success(res) {
    this.table.clearData();
    this.table.addData(res);
    this.table.setSort('expired_date', 'desc');
    this.filterStateObj.allData = res;
    this.load.hide();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }

  public download(e,cell){

  }
  
  }